/* eslint-disable import/no-duplicates */

import { isValid, parse } from 'date-fns';
import de from 'date-fns/locale/de';
import { format, utcToZonedTime } from 'date-fns-tz';

export const formatAmountToServer = (value: number | string) => {
  const multipliedValue = (Number(value) * 100).toFixed();

  return parseInt(multipliedValue, 10);
};
interface FormatCurrencyParams {
  amount: number;
  currency?: string;
  maximumFractionDigits?: number;
  options?: Intl.NumberFormatOptions;
}

export const formatCurrency = (params: FormatCurrencyParams) => {
  const {
    amount = 0,
    currency = 'EUR',
    maximumFractionDigits = 2,
    options,
  } = params;

  const formattedAmount = Number(amount).toLocaleString('DE-de', {
    style: 'currency',
    currency,
    maximumFractionDigits,
    ...options,
  });

  if (process.env.NODE_ENV === 'test') {
    return formattedAmount.replace(/\xa0/g, ' ').replace(/\u202f/g, ' ');
  }

  return formattedAmount;
};

export const formatPercentage = (
  value: number,
  options?: Intl.NumberFormatOptions,
) => {
  const formattedValue = new Intl.NumberFormat('DE-de', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  }).format(value);

  if (process.env.NODE_ENV === 'test') {
    return formattedValue.replace(/\xa0/g, ' ').replace(/\u202f/g, ' ');
  }

  return formattedValue;
};

export const parseDateFromServer = (date?: string) => {
  if (!date) return null;

  const parsedDate = parse(date, "yyyyMMdd'T'HHmmssX", new Date());

  if (!isValid(parsedDate)) return null;

  return parsedDate;
};

export const formatDateAsZmyleApi = (date: Date) => {
  if (!isValid(date)) return '';

  return date
    .toISOString()
    .replace(/-|:|\./g, '')
    .replace(/\d{3}Z$/, 'Z');
};
interface FormatDateToAppOptions {
  dateFormat?: 'dd.MM.yyyy' | 'dd.MM.yyyy HH:mm' | 'HH:mm';
  timezone: string | null | undefined;
}

export const formatDateToApp = (
  date: Date | string | null | undefined,
  options?: FormatDateToAppOptions,
) => {
  const { dateFormat = 'dd.MM.yyyy', timezone } = options ?? {};

  const timezoneId = timezone || 'Europe/Berlin';

  if (!date) return '';

  const dateToFormat =
    typeof date === 'string' ? parseDateFromServer(date) : date;

  if (!dateToFormat || !isValid(dateToFormat)) return '';

  const zonedDateTime = utcToZonedTime(dateToFormat, timezoneId);

  return format(zonedDateTime, dateFormat, {
    timeZone: timezoneId,
    locale: de,
  });
};
